import { render, staticRenderFns } from "./PharmacyCreateForm.vue?vue&type=template&id=2e5c03b4&scoped=true&"
import script from "./PharmacyCreateForm.vue?vue&type=script&lang=js&"
export * from "./PharmacyCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./PharmacyCreateForm.vue?vue&type=style&index=0&id=2e5c03b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5c03b4",
  null
  
)

export default component.exports